import * as TYPES from '@app/store/actionTypes';
import { TemplateAction } from '@app/store/template/actions';

type TemplateIsFetchingState = boolean;

const initialState: TemplateIsFetchingState = false;

export default function reducer(
  state: TemplateIsFetchingState = initialState,
  action: TemplateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_LOADING_START:
    case TYPES.TEMPLATE_EDIT_REQUEST:
    case TYPES.TEMPLATE__NEW_TEMPLATE_SAVE_REQUEST:
    case TYPES.TEMPLATE_FILE_CHANGE__PDF_INITIALIZE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return true;
    case TYPES.TEMPLATE_LOADING_FINISH:
    case TYPES.TEMPLATE_CREATE_FAILURE:
    case TYPES.TEMPLATE_EDIT_SUCCESS:
    case TYPES.TEMPLATE_EDIT_FAILURE:
    case TYPES.TEMPLATE__NEW_TEMPLATE_SAVE_SUCCESS:
    case TYPES.TEMPLATE__NEW_TEMPLATE_SAVE_FAILURE:
    case TYPES.TEMPLATE_FILE_CHANGE__PDF_LOAD_SUCCESS:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
    case TYPES.TEMPLATE_INFORMATION_FETCH_FAILURE:
      return false;
    default:
      return state;
  }
}
